import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Image as ImageIcon } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const PropertyImage = ({ imageUrl, idx }) => {
  const [imageSrc, setImageSrc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    let isMounted = true;

    const loadImage = async () => {
      try {
        const token = localStorage.getItem('adminToken');
        
        console.log(`[PropertyImage] Loading image ${idx + 1}`, {
          url: imageUrl,
          hasToken: !!token
        });

        if (!token) {
          throw new Error('No auth token found');
        }

        const response = await axios.get(imageUrl, {
          headers: {
            'Authorization': `Bearer ${token}`
          },
          responseType: 'blob',
          timeout: 10000
        });
        
        console.log(`[PropertyImage] Image ${idx + 1} loaded`, {
          status: response.status,
          size: response.data.size,
          type: response.data.type
        });

        if (isMounted && response.data) {
          const url = URL.createObjectURL(response.data);
          setImageSrc(url);
          setError(false);
        }
      } catch (err) {
        console.error(`[PropertyImage] Error loading image ${idx + 1}:`, {
          message: err.message,
          status: err.response?.status,
          data: err.response?.data
        });
        
        if (isMounted) {
          setError(true);
          setErrorMsg(err.message || 'Errore caricamento');
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadImage();

    return () => {
      isMounted = false;
      if (imageSrc) {
        URL.revokeObjectURL(imageSrc);
      }
    };
  }, [imageUrl, idx]);

  if (loading) {
    return (
      <div className="w-full h-full flex items-center justify-center bg-slate-100">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-600"></div>
      </div>
    );
  }

  if (error || !imageSrc) {
    return (
      <div className="w-full h-full flex flex-col items-center justify-center bg-slate-100 gap-2 p-2">
        <ImageIcon className="w-8 h-8 text-slate-400" />
        <span className="text-xs text-slate-500 text-center">{errorMsg || 'Errore'}</span>
      </div>
    );
  }

  return (
    <img
      src={imageSrc}
      alt={`Foto ${idx + 1}`}
      className="w-full h-full object-cover"
    />
  );
};

export default PropertyImage;
